export default __webpack_public_path__ + "static/media/mobile-16px.339776c8.svg";